import { Component, OnInit } from '@angular/core';

import { MetaService } from '../meta.service';
import { Contact } from './contact';
import { ContactService } from './contact.service';

@Component({
    selector: 'app-contact',
    templateUrl: './contact.component.html',
    styleUrls: ['./contact.component.min.css'],

})
export class ContactComponent implements OnInit {
    public lat = 51.056871;
    public lng = 3.733468;

    public contact = new Contact();
    public error: string = null;
    public submitted = false;
    public submitting = false;

    public constructor(private contactService: ContactService,
                       private metaService: MetaService) {
    }

    public ngOnInit(): void {
        this.metaService.updateMetaSettings({
            pageTitle: 'Contact',
            title: 'Contact us',
        });
    }

    public submit(): void {
        if (this.submitting) {
            return;
        }

        this.submitted = false;
        this.submitting = true;
        this.error = null;

        this.contactService.newContactRequest(this.contact)
            .subscribe(() => {
                this.submitted = true;
                this.submitting = false;
            }, () => {
                this.submitted = false;
                this.submitting = false;
                this.error = `An error occurred while submitting your request.
                    Please try again later.`;
            });
    }
}



// WEBPACK FOOTER //
// /Users/tom/Projects/mercit2018/src/app/contact/contact.component.ts